import { DIALOG_TYPE, LayoutConfig } from '@spartacus/storefront';
import {
  GonvarriImportEntriesDialogComponent
} from "../components/gonvarri-import-entries-dialog/gonvarri-import-entries-dialog.component";

export const gonvarriImportEntriesLayoutConfig: LayoutConfig = {
  launch: {
    IMPORT_TO_CART: {
      inlineRoot: true,
      component: GonvarriImportEntriesDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
  },
};
